__turbopack_context__.v({
  "closeButton": "SearchOverlay-module-scss-module__DY_pha__closeButton",
  "collectionLink": "SearchOverlay-module-scss-module__DY_pha__collectionLink",
  "collectionsWrapper": "SearchOverlay-module-scss-module__DY_pha__collectionsWrapper",
  "content": "SearchOverlay-module-scss-module__DY_pha__content",
  "dropdown": "SearchOverlay-module-scss-module__DY_pha__dropdown",
  "loading": "SearchOverlay-module-scss-module__DY_pha__loading",
  "overlay": "SearchOverlay-module-scss-module__DY_pha__overlay",
  "productsGrid": "SearchOverlay-module-scss-module__DY_pha__productsGrid",
  "productsSection": "SearchOverlay-module-scss-module__DY_pha__productsSection",
  "retailerLink": "SearchOverlay-module-scss-module__DY_pha__retailerLink",
  "searchContainer": "SearchOverlay-module-scss-module__DY_pha__searchContainer",
  "searchSection": "SearchOverlay-module-scss-module__DY_pha__searchSection",
  "showMoreWrapper": "SearchOverlay-module-scss-module__DY_pha__showMoreWrapper",
  "suggestedLabel": "SearchOverlay-module-scss-module__DY_pha__suggestedLabel",
  "title": "SearchOverlay-module-scss-module__DY_pha__title",
});
